"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserActivatePopup = UserActivatePopup;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _commons = require("@focaltec-suite/commons");
var _core = require("@focaltec-suite/core");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function UserActivatePopup(_ref) {
  var user = _ref.user,
    onClose = _ref.onClose;
  var _a;
  return /*#__PURE__*/_react["default"].createElement(_commons.DialogPopup, {
    title: (0, _core.translate)('users.activation.title'),
    onClose: onClose
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "body2",
    paragraph: true
  }, (0, _core.translate)('users.activation.content', user)), /*#__PURE__*/_react["default"].createElement(_commons.Clipboard, {
    value: "".concat(process.env.REACT_APP_ROOT_URL, "/signup/").concat((_a = user.signup_code) !== null && _a !== void 0 ? _a : 'invalid_code', "/password")
  }));
}